import { getReturnToURLFromParams } from '../../router/queryString';
import { loginUrl } from '@lessonnine/babbel-urls.js';

export default () => {
  const loginURL = loginUrl();
  const returnToURL = getReturnToURLFromParams();
  return returnToURL ? `${loginURL}?return_to=${encodeURIComponent(returnToURL)}` : loginURL;
};
